/**
 * Die Federn dieser App — Material 3 Expressive.
 *
 * Eine Regel trägt alles: Was sich BEWEGT, darf überschwingen. Was EIN- oder
 * AUSBLENDET, niemals. Eine Deckkraft, die über 1 hinausschießt und
 * zurückkommt, sieht aus wie ein Fehler; ein Knopf, der beim Erscheinen kurz
 * über sein Ziel hinausfedert, sieht lebendig aus.
 *
 * Ausgedrückt in der physikalischen Form von `motion` (`visualDuration` +
 * `bounce`, mit bounce ≈ 1 − Dämpfungsverhältnis). Keine Komponente schreibt
 * eigene Steifigkeit, Dämpfung, Dauer oder Kurve — alles kommt von hier.
 */
import type { Transition } from 'motion/react'

/* ---------- Räumlich: Überschwingen erlaubt (transform) ---------- */

/** Kleine Dinge, kurze Wege: Haken, Chip, Knopfdruck. */
export const fastSpatial: Transition = { type: 'spring', visualDuration: 0.22, bounce: 0.42 }

/** Der Normalfall: Karten, Blätter, der gleitende Navigationspunkt. */
export const defaultSpatial: Transition = { type: 'spring', visualDuration: 0.4, bounce: 0.3 }

/** Große Auftritte: ein Blatt, das die halbe Seite einnimmt. */
export const slowSpatial: Transition = { type: 'spring', visualDuration: 0.62, bounce: 0.5 }

/* ---------- Effekte: KEIN Überschwingen (opacity, Farbe) ---------- */

export const effectsFast: Transition = { type: 'spring', visualDuration: 0.16, bounce: 0 }
export const effectsDefault: Transition = { type: 'spring', visualDuration: 0.3, bounce: 0 }

/* ---------- Rückfall für „weniger Bewegung" ---------- */

/** Kurz, flach, ohne Weg. */
export const reducedFade: Transition = { duration: 0.12, ease: 'linear' }

/* ---------- Helfer ---------- */

/** Treppenverzögerung für Listen: das erste Kind läuft sofort. */
export const staggerIn = (
  index: number,
  base = 0.05,
  transition: Transition = defaultSpatial,
): Transition => ({ ...transition, delay: index * base })
